function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 256h43c0 114 92 206 206 206s206-92 206-206S370 50 256 50V7c137 0 249 112 249 249S393 505 256 505 7 393 7 256zm202 70V186c0-13 14-20 24-13l102 71c8 6 8 18 0 24l-102 71c-10 7-24 0-24-13z"
}));